import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import LoaiDuAn from './loai-du-an';
import LoaiDuAnDetail from './loai-du-an-detail';
import LoaiDuAnUpdate from './loai-du-an-update';
import LoaiDuAnDeleteDialog from './loai-du-an-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={LoaiDuAnUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={LoaiDuAnUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={LoaiDuAnDetail} />
      <ErrorBoundaryRoute path={match.url} component={LoaiDuAn} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={LoaiDuAnDeleteDialog} />
  </>
);

export default Routes;
